module.exports = __webpack_public_path__ + "img/ys2.e5f59734.png";